export interface IReport {
    name: string
    fileName: string
    fileExtension: string
    formattedData: string
}

const getReportName = (report: IReport, dateFrom: string, dateTo: string): string =>
    `${report.name}_${dateFrom}--${dateTo}.${report.fileExtension}`

export default getReportName
